export default "__VITE_ASSET__BOxG1ArI__"